import axios from 'axios';

interface JudgeSubmission {
  language: string;
  version: string;
  files: { content: string; name: string }[];
  stdin?: string;
}

interface JudgeResponse {
  stdout: string;
  stderr: string;
  output: string;
  code: number;
  signal?: string;
}

export class JudgeService {
  private readonly baseUrl = 'https://emkc.org/api/v2/piston/execute';

  async runCode(code: string, input?: string, language?: string): Promise<JudgeResponse> {
    try {
      // Default to python3 if language not provided
      const lang = language || 'python3';
      // Default version for common languages
      const defaultVersions: Record<string, string> = {
        python3: '3.10.0',
        javascript: '18.15.0',
        java: '15.0.2',
        cpp: '10.2.0',
        c: '10.2.0',
      };
      const version = defaultVersions[lang] || '*';
      const fileName = `Main.${lang === 'python3' ? 'py' : lang === 'javascript' ? 'js' : lang === 'java' ? 'java' : lang === 'cpp' ? 'cpp' : lang === 'c' ? 'c' : 'txt'}`;
      const submission: JudgeSubmission = {
        language: lang,
        version,
        files: [{ name: fileName, content: code }],
      };
      if (input) {
        submission.stdin = input;
      }
      const response = await axios.post(this.baseUrl, submission, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = response.data;
      return {
        stdout: data.run.stdout,
        stderr: data.run.stderr,
        output: data.run.output || data.run.stdout || data.run.stderr,
        code: data.run.code,
        signal: data.run.signal
      };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        console.error('Piston API Error:', error.response.data);
        throw new Error(error.response.data.message || 'Piston API error');
      }
      console.error('Piston API Error:', error);
      throw error;
    }
  }
}

export const judgeService = new JudgeService();
